import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 15"
};
function t(d, e) {
  return o(), l("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.737 1.045A.75.75 0 0 1 4.333.75h8.334a.75.75 0 0 1 .596.295l3.333 4.363a.75.75 0 0 1-.051.971l-7.222 7.636a.75.75 0 0 1-1.07.02L.474 6.4a.75.75 0 0 1-.071-.99zm.967 1.205L2.517 5.114h11.966L12.296 2.25zm9.554 4.364H2.834l5.924 5.816z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const i = { render: t };
export {
  i as default,
  t as render
};
